import { addTranslation } from '../../../_helpers/Translate';

addTranslation({
  ru: {
    sidebar_title: 'Навигация',
    sidebar_home: 'Главная',
    sidebar_users: 'Пользователи',
    sidebar_exit: 'Выход',
    sidebar_requests: 'Заявки в обработке',
    sidebar_completedRequests: 'Завершенные заявки',
    sidebar_ddo: 'Заявки на электронную очередь в ДДО',
    sidebar_queue_title: 'Очередь в детский сад',
    sidebar_queue_applications: 'Заявления',
    sidebar_queue_appointments: 'Направления',
    sidebar_queue_notifications: 'Уведомления',
    sidebar_queue_accompaniment: 'Сопровождение',
    sidebar_voucher_title: 'Очередь на ваучер',
    sidebar_voucher_applications: 'Заявления на ваучер',
    sidebar_voucher_appointments: 'Ваучеры',
    sidebar_voucher_notifications: 'Уведомления',
    sidebar_voucher_agreements: 'Договора',
    sidebar_voucher_waitingList: 'Лист ожидании'
  },
  kk: {
    sidebar_title: 'Навигация',
    sidebar_home: 'Главная',
    sidebar_users: 'Пользователи',
    sidebar_exit: 'Выход',
    sidebar_requests: 'Өңдеудегі өтінімдер',
    sidebar_completedRequests: 'Аяқталған өтінімдер',
    sidebar_ddo: 'Электрондық кезекке өтініштер',
    sidebar_queue_title: 'Очередь в детский сад',
    sidebar_queue_applications: 'Өтініштер',
    sidebar_queue_appointments: 'Жолдамалар',
    sidebar_queue_notifications: 'Хабарламалар',
    sidebar_queue_accompaniment: 'Сопровождение',
    sidebar_voucher_title: 'Очередь на ваучер',
    sidebar_voucher_applications: 'Ваучерге өтініштер',
    sidebar_voucher_appointments: 'Ваучерлер',
    sidebar_voucher_notifications: 'Хабарламалар',
    sidebar_voucher_agreements: 'Шарттар',
    sidebar_voucher_waitingList: 'Күту парағы'
  }
});
